export default "__VITE_ASSET__21cf8e54__"